import { UsageDashboard } from "@/components/Settings/UsageDashboard";

export function SettingsUsage() {
  return (
    <div className="space-y-6 p-6">
      <div>
        <h1 className="text-3xl font-bold">Usage Dashboard</h1>
        <p className="mt-2 text-muted-foreground">
          Monitor how users interact with internal applications — companies ingested,
          simulations run, and chat activity.
        </p>
      </div>
      <UsageDashboard />
    </div>
  );
}
